import { render } from "./ManagerFooter.vue?vue&type=template&id=67e68c44&scoped=true"
import script from "./ManagerFooter.vue?vue&type=script&lang=js"
export * from "./ManagerFooter.vue?vue&type=script&lang=js"

import "./ManagerFooter.vue?vue&type=style&index=0&id=67e68c44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e68c44"]])

export default __exports__